// Combines all sagas from modules into one array.
import {all} from 'redux-saga/effects';
import sagaMiddleware from 'middleware/saga';
import {forkSafely} from './sagaUtils';

const moduleSagas = import.meta.webpackContext(
    './',
    {recursive: true, regExp: /\.\/\w+\/sagas(.js|\/index.js)/, mode: 'sync'}
);

const sagas = moduleSagas.keys().reduce((memo, path) => {
    let saga = moduleSagas(path);
    if (saga.default) {
        saga = saga.default;
    }
    // Only add if it's a function.
    if (typeof saga === 'function') {
        memo.push(saga);
    }

    return memo;
}, []);

export default function* rootSaga() {
    yield all(sagas.map(saga => forkSafely(saga)));
}

export const runSagas = () => sagaMiddleware.run(rootSaga);